import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import './CustomModal.component.scss'

const CustomModal = ({
  isOpen,
  onClose,
  children,
  title,
  size = 'lg',
  modalId = 'CareerRequestModalComponent',
  disableBackdrop = true,
}) => {
  // Close modal when pressing Escape key
  useEffect(() => {
    const handleEscape = e => {
      if (e.key === 'Escape') onClose()
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'auto'
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div
      data-test='modal'
      className='modal custom-modal fade top show'
      id={modalId}
      tabIndex='-1'
      role='dialog'
      aria-hidden='true'
      style={{ display: 'block' }}
      data-disablebackdrop={disableBackdrop.toString()}
    >
      <div className={`modal-lg modal-dialog`} role='document'>
        <div className='modal-content'>
          <div data-test='modal-header' className='modal-header'>
            <h4 className='modal-title'>{title}</h4>
            <button type='button' className='close' onClick={onClose} aria-label='Close'>
              <span aria-hidden='true'>×</span>
            </button>
          </div>
          <div data-test='modal-body' className='modal-body'>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

CustomModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  title: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  modalId: PropTypes.string,
  disableBackdrop: PropTypes.bool,
}

export default CustomModal
